import Axios from 'axios';
import cookie from 'react-cookies';
import { API_URI } from '../Constant';
import { handelError, header } from './Axios';
import { getExpireDate } from '.';

const TOKEN = '_e_token_';
const REFRESH = '_r_token_'

export const requestAuth = async (creds) => {
  return await Axios.post(`${API_URI}/api/auth/signin`, creds, header)
    .then(({ data }) => data)
    .catch(handelError);
};

export const isAuth = () => {
  const token = cookie.load(TOKEN);
  if (!token || token === '') return false;
  else return true;
};

export const saveToken = (Token, expires) => {
  const tokenexpiry = getExpireDate(expires / (24 * 60 * 60 * 1000))
  localStorage.setItem(TOKEN, tokenexpiry)
  const oneYearInMs = 365 * 24 * 60 * 60 * 1000; // 1 year in milliseconds
  const refreshexpiryset = new Date(Date.now() + oneYearInMs);
  if (Token) cookie.save(TOKEN, Token, { expires: refreshexpiryset });
};
export const saveRefreshToken = (Token, expires) => {
  const refreshexpiry = getExpireDate(expires / (24 * 60 * 60 * 1000))

  localStorage.setItem(REFRESH, refreshexpiry)

  const oneYearInMs = 365 * 24 * 60 * 60 * 1000; // 1 year in milliseconds
  const refreshexpiryset = new Date(Date.now() + oneYearInMs);


  if (Token) cookie.save(REFRESH, Token, { expires: refreshexpiryset });
};
export const getToken = () => {
  return cookie.load(TOKEN);
};
export const getRefreshToken = () => {
  return cookie.load(REFRESH);
};
export const removeToken = () => {
  cookie.remove(TOKEN);
  cookie.remove(REFRESH);
  localStorage.clear()
};
// Timer and auto-refresh logic
let refreshTimer;
export const scheduleTokenRefresh = (refreshFn) => {
  clearTimeout(refreshTimer);

  const expiry = parseInt(localStorage.getItem(TOKEN), 10);
  const now = Date.now();

  if (!expiry || isNaN(expiry)) return;

  const timeUntilRefresh = expiry - now - 1 * 60 * 1000; // refresh 5 minutes before expiry

  if (timeUntilRefresh <= 0) {
    refreshFn();
  } else {
    refreshTimer = setTimeout(() => {
      refreshFn();
    }, timeUntilRefresh);
  }
};
// export const saveToken = (Token) => {
//   if (Token) cookie.save(TOKEN, Token, { expires: getExpireDate() });
// };
// Post-login redirect helpers
const REDIRECT_PARAM = 'redirect';

// Pages that must never become a post-login destination.
const NON_REDIRECTABLE_PATHS = [
  '/login',
  '/password_reset',
  '/forgot_password',
  '/forgotpassword',
  '/signup',
];

const isRedirectablePath = (path) => {
  if (!path || typeof path !== 'string') return false;
  // Only allow internal paths ("//host" and "http://host" are external).
  if (!path.startsWith('/') || path.startsWith('//')) return false;
  const [pathname] = path.split(/[?#]/);
  if (pathname === '/') return false;
  return !NON_REDIRECTABLE_PATHS.includes(pathname);
};

export const getCurrentPath = () =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`;

// Builds the login url, remembering where the user was so we can send them back.
export const buildLoginUrl = (path = getCurrentPath()) => {
  if (!isRedirectablePath(path)) return '/login';
  return `/login?${REDIRECT_PARAM}=${encodeURIComponent(path)}`;
};

// Where to send the user once they are logged in.
export const getPostLoginRedirect = (search = window.location.search) => {
  let target = null;
  try {
    target = new URLSearchParams(search).get(REDIRECT_PARAM);
  } catch {
    target = null;
  }
  return isRedirectablePath(target) ? target : '/';
};
